import { Statement } from 'app/statements';

import { VatDeclaration } from './vat-declaration.model';
import {
  declarationTypes
} from "../../components/additional-income-form/additional-income-form-vat/additional-income-form-vat.component";


export class VatDeclarationManager {
  public static getVatDeclaration(statement: Statement): VatDeclaration[] | {}[] {
    return VatDeclarationManager.get(statement) ? [VatDeclarationManager.get(statement)] : [];
  }

  public static createVatDeclaration(statement: Statement): VatDeclaration {
    return VatDeclarationManager.create(
      statement
    );
  }

  public static removeVatDeclaration(statement: Statement): void {
    VatDeclarationManager.remove(
      statement
    );
  }

  public static get(statement: Statement): VatDeclaration | {} {

    return statement.vatDeclaration;
  }

  public static create(statement: Statement): VatDeclaration {
    const vatDeclaration = new VatDeclaration();
    vatDeclaration.declaration_type = declarationTypes.BUSINESS;

    statement.vatDeclaration = vatDeclaration;

    return vatDeclaration;
  }

  public static remove(statement: Statement): void {
     statement.vatDeclaration = {};
  }
}
